'use client';

import {
  useEffect,
  useRef,
} from 'react';
import {
  usePathname,
} from 'next/navigation';
import {
  useQueryClient,
} from '@tanstack/react-query';

export default function AppointmentQueryRefresher() {
  const pathname = usePathname();
  const queryClient = useQueryClient();
  const previousPathnameRef = useRef(pathname);

  useEffect(() => {
    const isAppointmentsRoute = pathname === '/appointments' || pathname.startsWith('/appointments/');
    const cameFromAnotherRoute = previousPathnameRef.current !== pathname;

    if (isAppointmentsRoute && cameFromAnotherRoute) {
      queryClient.invalidateQueries({ queryKey: ['upcoming-visits'] });
      queryClient.invalidateQueries({ queryKey: ['past-visits'] });
    }

    previousPathnameRef.current = pathname;
  }, [pathname, queryClient]);

  return null;
}
